<template>
    <v-container>
        <v-row v-if="bookmarkClients.length > 0" class="bookmarks" justify="center">
            <v-col md="6">
                <v-row>
                    <v-col v-for="(client, index) in bookmarkClients" :key="index" cols="12" sm="6">
                        <v-card @click="selectClient(client.id)" class="client">
                            <v-icon class="bookmark" @click.stop.prevent="bookmark(client.id)">mdi-star-outline</v-icon>
                            <v-card-title><img class="logo" :src="`data:image/png;base64,${client.logo}`" /></v-card-title>
                            <v-card-subtitle>{{ client.name }}</v-card-subtitle>
                            <v-icon class="goto">mdi-chevron-right</v-icon>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-if="clients.length > 0" justify="center">
            <v-col md="6">
                <v-row>
                    <v-col v-for="(client, index) in clients" :key="index" cols="12" sm="6">
                        <v-card @click="selectClient(client.id)" class="client">
                            <v-icon class="bookmark" @click.stop.prevent="bookmark(client.id)">mdi-star-outline</v-icon>
                            <v-card-title><img class="logo" :src="`data:image/png;base64,${client.logo}`" /></v-card-title>
                            <v-card-subtitle>{{ client.name }}</v-card-subtitle>
                            <v-icon class="goto">mdi-chevron-right</v-icon>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import { api } from '@/utils/api';

export default {
    methods: {
        ...mapMutations('languages', ['setLanguages', 'selectLang']),
        ...mapMutations(['setBookmark', 'setClientsBookmarks']),
        async selectClient(id) {
            this.$store.commit('setCurrent', id);
            const client = this.$store.state.clients.list.find(cli => cli.id === id);
            if (client) {
                this.setLanguages(client.languages);
                const language = JSON.parse(localStorage.getItem('language') || '{}');
                const userLang = language[client.id] || client.defaultLang || 'en';
                await api.setLang(userLang, this.$i18n, this.$vuetify);
                this.selectLang(userLang);
                this.$session.start();
                this.$session.set('languages', client.languages);
                this.$session.set('defaultLang', userLang);
            }
            this.$router.push(`/${this.$store.getters.getClientName}`);
        },
        async bookmark(id) {
            this.$store.commit('setBookmark', id);
            await api.post(['bookmarks', 'toggleBookmark'], null, this.bookmarks, null);
        }
    },
    computed: {
        ...mapState({
            bookmarks: state => state.clients.bookmarks
        }),
        ...mapGetters({
            bookmarkClients: 'getBookmarks',
            clients: 'getClients'
        })
    },
    watch: {
        async '$store.state.user.informations'() {
            if (Object.keys(this.$store.state.user.informations).length !== 0 && Object.keys(this.bookmarks).length === 0) {
                const bookmarkedClients = await api.get(['bookmarks', 'getBookmarks']);
                this.setClientsBookmarks(bookmarkedClients);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
.logo {
    max-height: 50px;
    max-width: 100%;
}
.bookmarks {
    margin-bottom: 30px;
    .bookmark {
        color: $yellow !important;
    }
}
.client {
    cursor: pointer;
    border-top: 7px solid #fff;
    padding-right: 40px;
    height: 100%;
    .v-card__subtitle {
        padding-top: 10px;
        padding-bottom: 21px;
    }
    .goto {
        color: $primary;
        border-radius: 50% !important;
        position: absolute;
        right: 10px;
        bottom: 20px;
    }
    &:hover {
        border-top: 7px solid $primary;
        .goto {
            background-color: $primary;
            color: #fff;
        }
    }
    .bookmark {
        color: $lighter-grey;
        position: absolute;
        right: 10px;
        top: 20px;
        &:hover {
            color: $yellow;
        }
    }
}
</style>
